import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center justify-center align-middle font-bold"
}
const _hoisted_3 = {
  key: 1,
  class: "flex items-center justify-center align-middle font-bold"
}
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = { class: "absolute right-0 top-0 mb-8" }
const _hoisted_6 = { class: "max-h-[60rem] min-h-[15rem] w-full" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "flex items-center justify-center align-middle font-bold" }, " Tempteratures ", -1)
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = { class: "absolute right-0 top-0 mb-8" }
const _hoisted_11 = { class: "max-h-[60rem] min-h-[15rem] w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheButton = _resolveComponent("TheButton")!
  const _component_Line = _resolveComponent("Line")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.devices[0].data[0].payload.records, (chart, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        (
        (chart.dataChart[0].datasets[0].data[0] ||
          chart.dataChart[0].datasets[0].data.length > 1) &&
        chart.id !== 54 &&
        chart.id !== 55
      )
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (chart.labelName && chart.labelName.en)
                ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(chart.labelName.en), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_3, " Name not found ")),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_TheButton, {
                    text: 'Zoom in',
                    onClick: () => _ctx.zoomIn(chart, chart.id),
                    class: "!h-fit",
                    size: 'sm',
                    variant: 'ghost'
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_TheButton, {
                    text: 'Zoom out',
                    onClick: () => _ctx.zoomOut(chart, chart.id),
                    class: "!h-fit",
                    size: 'sm',
                    variant: 'ghost'
                  }, null, 8, ["onClick"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_Line, {
                    id: chart.id,
                    data: chart.dataChart[0],
                    options: chart.chartOptions
                  }, null, 8, ["id", "data", "options"])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.sensorDataForGraph as any), (graph) => {
      return (_openBlock(), _createElementBlock("div", null, [
        graph
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_TheButton, {
                    text: 'Zoom in',
                    onClick: () => _ctx.zoomIn(graph, graph.typeOfSensor),
                    class: "!h-fit",
                    size: 'sm',
                    variant: 'ghost'
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_TheButton, {
                    text: 'Zoom out',
                    onClick: () => _ctx.zoomOut(graph, graph.typeOfSensor),
                    class: "!h-fit",
                    size: 'sm',
                    variant: 'ghost'
                  }, null, 8, ["onClick"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_Line, {
                    id: graph.typeOfSensor,
                    data: graph,
                    options: _ctx.optionsForOldDevice
                  }, null, 8, ["id", "data", "options"])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 256))
  ], 64))
}